import React from 'react';

const ProductReports: React.FC = () => {
	return <></>;
};

export default ProductReports;
